import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function userReducer(state = initialState.users, action) {
  let newState;

  switch (action.type) {
    case types.LOGOUT:
      newState = objectAssign({}, state);
      newState.loggedIn = false;
      newState.currentUser = {};
      return newState;

    case types.LOGIN_SUCCESS:
      newState = objectAssign({}, state);
      newState.loggedIn = true;
      return newState;

    case types.LOGIN_FAILED:
      newState = objectAssign({}, state);
      newState.login_error = action.error;
      newState.loggedIn = false;
      return newState;

    case types.LOAD_USERS:
      newState = objectAssign({}, state, {loading: true});
      return newState;

    case types.LOAD_USERS_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.list = action.list;
      newState.listUpdated = action.listUpdated;
      return newState;

    case types.LOAD_USERS_FAILURE:
      newState = objectAssign({}, state, {loading: false});
      newState.list = action.list;
      newState.listUpdated = action.listUpdated;
      return newState;

    case types.LOAD_USER_DETAILS:
      newState = objectAssign({}, state, {loading: true});
      newState.details = initialState.users.details;
      newState.errors = initialState.users.errors;
      return newState;

    case types.LOAD_USER_DETAILS_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.details = action.details;
      newState.detailsUpdated = action.detailsUpdated;
      return newState;

      case types.LOAD_USER_DETAILS_FAILURE:
      newState = objectAssign({}, state, {loading: false});
      newState.errors = action.errors;
      return newState;

    case types.LOAD_CURRENT_USER:
      newState = objectAssign({}, state, {loading: true});
      return newState;

    case types.LOAD_CURRENT_USER_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.currentUser = action.details;
      localStorage.currentUser = JSON.stringify(action.details);
      return newState;

    case types.LOAD_CURRENT_USER_FAILURE:
      newState = objectAssign({}, state, {loading: false});
      newState.errors = action.errors;
      return newState;

    case types.UPDATE_USER_PASSWORD:
      newState = objectAssign({}, state, {loading: true});
      return newState;

    case types.UPDATE_USER_PASSWORD_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.errors = {};
      return newState;

    case types.LOAD_GROUPS:
      newState = objectAssign({}, state, {loading: true});
      return newState;

    case types.LOAD_GROUPS_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.groups = action.list;
      newState.groupListUpdated = action.groupListUpdated;
      return newState;

    case types.LOAD_GROUPS_FAILURE:
      newState = objectAssign({}, state, {loading: false});
      return newState;

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/userReducer.js
 **/